<template>
  <div class="pagination-v3">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      background
      :page-sizes="pageSizes"
      :page-size="size"
      layout="slot, prev, pager, next, sizes, jumper"
      :total="total"
    >
      <div class="el-pagination__total">{{ total + " in total" }}</div>
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "common-pagination-v4",
  data() {
    return {};
  },
  props: {
    total: {
      default: 400,
      type: Number,
    },
    currentPage: {
      default: 1,
      type: Number,
    },
    size: {
      default: 20,
      type: Number,
    },
    pageSizes: {
      default: () => [20, 50, 100, 200],
      type: Array,
    },
  },
  computed: {},
  watch: {},
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.$emit("changeSize", val);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.$emit("handleCurrentChange", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination-v3 {
  padding: 10px 0;
  background: #ffffff;
  position: fixed;
  width: calc(100% - 72px);
  height: 44px;
  bottom: 0;
  right: 0;
  z-index: 100;
  box-shadow: inset 0px 1px 0px #e7ebf3;
  ::v-deep {
    .el-pagination {
      display: flex;
      justify-content: center;
      padding: 0;
      .el-pagination__total {
        font-family: "OpenSans";
        font-weight: 600;
        font-size: 12px;
        color: #000000;
        line-height: 24px;
      }
      .btn-prev,
      .btn-next {
        min-width: 26px;
        height: 24px;
        line-height: 24px !important;
        border: 1px solid #ebeef4;
        border-radius: 4px;
        background-color: #ffffff !important;
        font-family: "OpenSans";
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        color: #4066d4 !important;
        &:hover {
          border-color: #4066d4 !important;
        }
        .el-icon-arrow-left {
          display: inline-block;
          width: 9px;
          height: 13px;
          transform: rotate(180deg);
          background: url("~@/assets/img/com-2/pagination-new-current-icon.svg")
            no-repeat;
          color: #4066d4;
          &::before {
            display: none;
          }
        }
        .el-icon-arrow-right {
          display: inline-block;
          width: 9px;
          height: 13px;
          color: #4066d4;
          background: url("~@/assets/img/com-2/pagination-new-current-icon.svg")
            no-repeat;
          &::before {
            display: none;
          }
        }
        &:disabled {
          color: #b1b6c1 !important;
          &:hover {
            color: #b1b6c1 !important;
            border-color: #ebeef4 !important;
          }
          .el-icon-arrow-left {
            transform: rotate(360deg);
            background: url("~@/assets/img/com-2/pagination-new-icon.svg")
              no-repeat;
          }
          .el-icon-arrow-right {
            transform: rotate(180deg);
            background: url("~@/assets/img/com-2/pagination-new-icon.svg")
              no-repeat;
          }
        }
      }
      span:not([class*="suffix"]),
      button {
        height: 24px;
        line-height: 24px;
        font-family: "OpenSans";
        font-weight: 600;
        font-size: 12px;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        .el-input--mini .el-input__inner {
          height: 24px;
          line-height: 24px;
          font-family: "OpenSans";
          font-weight: 600;
          font-size: 13px;
          color: #000c2e;
        }
        .el-input__suffix {
          display: flex;
          align-items: center;
          justify-content: center;
          .el-icon-arrow-up {
            display: inline-block;
            width: 13px;
            height: 7px;
            transform: rotate(0deg);
            margin-right: 10px;
            background: url("~@/assets/img/com-2/pagination-dropdown-icon.svg")
              no-repeat;
            &::before {
              display: none;
            }
            &::after {
              display: none;
            }
          }
          .el-icon-arrow-up.is-reverse {
            transform: rotate(180deg);
          }
        }
      }
      .el-pager {
        li {
          min-width: 26px;
          height: 24px;
          line-height: 24px !important;
          border: 1px solid #ebeef4;
          border-radius: 4px;
          background-color: #ffffff !important;
          font-weight: 600;
          font-size: 12px;
          line-height: 16px;
          text-align: center;
          color: #000000 !important;
          &:hover {
            color: #4066d4 !important;
            border-color: #4066d4 !important;
          }
        }
        li.active {
          color: #4066d4 !important;
          border-color: #4066d4 !important;
        }
        li.more {
          &::before {
            line-height: 24px;
          }
        }
      }
      .el-pagination__jump {
        &::after {
          content: "Page";
        }
        .el-pagination__editor.el-input {
          height: 24px;
          .el-input__inner {
            height: 24px;
            font-family: "OpenSans";
            font-weight: 600;
            font-size: 13px;
            color: #000c2e;
          }
        }
      }
    }
  }
}
</style>
